import { generateAvatar } from "../../../utils";
import icon_trash from '../../../assets/images/icon_trash.svg';
import { ContextState } from "../../../layout";
import { useContext, useState } from "react";
import CustomModal from "../../../hoc/CustomModal";
import PopComponent from "../../popContent";
import { deleteUserCourse, deleteUserCourseCareer, deleteUserCoursePreCollege ,deleteUserCoursecertificates, deleteUserProgramDL } from "../../../api/users";
import { useDispatch } from "react-redux";
import { preCourseUnenroll } from "../../../redux/preCollageUser/action";
import {certCourseUnenroll} from "../../../redux/CertCourseUser/action"
import { useSelector } from "react-redux";
import { courseUnenroll } from "../../../redux/user/action";
import { CareerCourseUnenroll } from "../../../redux/careerLaunchUser/action";
import { DLProgramUnenroll } from "../../../redux/DlUser/action"
import Cookies from 'js-cookie';

const UserEnrolledPop = ({ userdata, userInfo, userId }) => {
    const [modalName, setModalName] = useState("ErrorPop");
    const [openModal, setModalOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [error, setError] = useState({});
    let Modal = PopComponent[modalName];
    const { contextReducer } = useContext(ContextState);
    const dispatch = useDispatch();
    let fullName = userdata?.email;
    const careerUsers = useSelector(state => state.careerLaunchUserReducer);
    const preUsers = useSelector(state => state.preCollageUserReducer);
    const skillUpUsers = useSelector(state => state.userReducer);
    const CertUser = useSelector(state => state.CertCourseUserReducer)
    const DLUser = useSelector(state => state.DlUserReducer)

    const role = Cookies.get('cms_role');
    
    const DLProgram = DLUser?.filter(_ => _._id === userId);
    let course = (contextReducer.cms_type === 'career-launch' ? careerUsers : contextReducer.cms_type === 'pre-college' ? preUsers :contextReducer.cms_type === 'certificates' ? CertUser:  contextReducer.cms_type === 'dl-program' ? DLUser : skillUpUsers)?.filter(_ => _._id === userId)[0]?.enroll_course;

    const unEnrolledCourse = () => {
        const data = {
            user_id: userId,
            course_id: deleteId
        };
        const dlData = {
            user_id: userId,
            program_id: deleteId 
        };
        (contextReducer.cms_type === 'career-launch' ? deleteUserCourseCareer(data) : contextReducer.cms_type === 'pre-college' ? deleteUserCoursePreCollege(data) :contextReducer.cms_type === 'certificates' ? deleteUserCoursecertificates(data) :  contextReducer.cms_type === 'dl-program' ? deleteUserProgramDL(dlData) : deleteUserCourse(data)).then(res => {
            if (res.data.status === 200) {
                dispatch(contextReducer.cms_type === 'career-launch' ? CareerCourseUnenroll(data) : contextReducer.cms_type === 'pre-college' ? preCourseUnenroll(data) : contextReducer.cms_type === 'certificates' ? certCourseUnenroll(data):contextReducer.cms_type === 'dl-program' ?  DLProgramUnenroll(dlData) : courseUnenroll(data));
                handleOpenModal('ErrorPop', { header: "Success", body: res.data.message });
            } else if (res.data.status === 103) {
                handleOpenModal('ErrorPop', { header: "Info", body: res.data.message })
            } else {
                handleOpenModal('ErrorPop', { header: "Error", body: res.data.message });
            }
        }).catch(err => {
            handleOpenModal('ErrorPop', { header: "Error", body: err.message })
        })
        handleOpenModal();
    };

    const handleOpenModal = (type, data) => {
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data);
                setModalOpen(true);
                break;
            }
            case 'UserDeleteAlert': {
                setModalName('DeletePop');
                setDeleteId(data.course_id || data?.event_id || data._id);
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setDeleteId(null);
                setModalOpen(!openModal);
                break;
            }
        }
    };

    const handleModalClose = () => {
        setDeleteId(null);
        setModalOpen(false);
    };

    return (
        <>
            <div className="modal_header">
                <div className="user_info">
                    <div className="user_info_img">
                        <img src={generateAvatar(fullName)} alt="User profile" height="42" width="42" className="radius_rounded img_object_center" />
                    </div>
                    <div className="user_info_name_work">
                        <p className="user_work">{fullName}</p>
                    </div>
                </div>
            </div>
            <div className="courses_user_counter_table_model">
                <div className="table_responsive fullWidth vert_scroll counter_course">
                    <table className="table">
                        <tbody>
                            <tr>
                                <th><p>{contextReducer.cms_type === 'dl-program' ? 'Program Name' : 'Course Name' } </p></th>
                                {contextReducer.cms_type !== 'skill-up' && <th><p>{userInfo ? 'Status' : contextReducer.cms_type === 'dl-program' ? "Program Id" : 'Course Id'}</p></th>}
                                <th><p> </p></th>
                            </tr>
                            {course?.length ?
                                course?.map(_ =>
                                    <tr>
                                        <td>{_?.name}</td>
                                        {contextReducer.cms_type !== 'skill-up' && <td><span class={`float_right ${userInfo ? _?.course_status ?role === "Contributor"  ?  'btn_success contributor_status' :  'btn_success' : 'btn_inprogress' : ''}`}>{userInfo ? _?.course_status ? 'Completed' : 'In Progress' : _?.courseId}</span></td>}
                                        {role !== "Contributor" &&  <td><span class={`d_block text_center`} onClick={() => handleOpenModal('UserDeleteAlert', _)}><img src={icon_trash} alt="Trash icon" height="14" className="cursor_pointer" /></span></td> }
                                    </tr>
                                )
                                :   contextReducer.cms_type === 'dl-program' && DLProgram[0]?.enroll_program[0]?.coursedetails?.program_name ?
                                <tr>
                                        <td>{DLProgram[0]?.enroll_program[0]?.coursedetails?.program_name}</td>
                                        <td>{DLProgram[0]?.enroll_program[0]?.coursedetails?.programID}</td>
                                        {role !== "Contributor" &&  <td><span class={`d_block text_center`} onClick={() => handleOpenModal('UserDeleteAlert', DLProgram[0]?.enroll_program[0])}><img src={icon_trash} alt="Trash icon" height="14" className="cursor_pointer" /></span></td> }
                                </tr> 
                                
                                :  <tr><td colSpan={contextReducer.cms_type !== 'skill-up' ? 3 : 2} className="text_center" style={{ padding: '4rem 0' }}>No Data Found</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {
                Modal && (
                    <CustomModal className={`${modalName === 'UserInfo' ? "modal fullWidth" : modalName === 'AddUser' ? "modal add_user" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleModalClose} open={openModal}>
                        <Modal
                            error={error}
                            setModalOpen={setModalOpen}
                            handleDelete={unEnrolledCourse}
                            handleOpenModal={handleOpenModal}
                            handleModalClose={handleModalClose}
                        />
                    </CustomModal>
                )
            }
        </>
    )
};

export default UserEnrolledPop